/* tslint:disable */
/* eslint-disable */
/**
 * Melco Fusion APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    FusionMelcoModelsCustomWarning,
    FusionMelcoModelsCustomWarningFromJSON,
    FusionMelcoModelsCustomWarningFromJSONTyped,
    FusionMelcoModelsCustomWarningToJSON,
    FusionMelcoModelsDesignElement,
    FusionMelcoModelsDesignElementFromJSON,
    FusionMelcoModelsDesignElementFromJSONTyped,
    FusionMelcoModelsDesignElementToJSON,
    FusionMelcoModelsPreview,
    FusionMelcoModelsPreviewFromJSON,
    FusionMelcoModelsPreviewFromJSONTyped,
    FusionMelcoModelsPreviewToJSON,
} from './';

/**
 * 
 * @export
 * @interface FusionMelcoModelsDesign
 */
export interface FusionMelcoModelsDesign {
    /**
     * 
     * @type {string}
     * @memberof FusionMelcoModelsDesign
     */
    id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FusionMelcoModelsDesign
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FusionMelcoModelsDesign
     */
    file_name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FusionMelcoModelsDesign
     */
    signature?: string | null;
    /**
     * 
     * @type {number}
     * @memberof FusionMelcoModelsDesign
     */
    stitches?: number;
    /**
     * 
     * @type {number}
     * @memberof FusionMelcoModelsDesign
     */
    colors?: number;
    /**
     * 
     * @type {number}
     * @memberof FusionMelcoModelsDesign
     */
    trims?: number;
    /**
     * 
     * @type {number}
     * @memberof FusionMelcoModelsDesign
     */
    color_changes?: number;
    /**
     * 
     * @type {string}
     * @memberof FusionMelcoModelsDesign
     */
    unit?: string | null;
    /**
     * 
     * @type {number}
     * @memberof FusionMelcoModelsDesign
     */
    height?: number;
    /**
     * 
     * @type {number}
     * @memberof FusionMelcoModelsDesign
     */
    width?: number;
    /**
     * 
     * @type {number}
     * @memberof FusionMelcoModelsDesign
     */
    file_size?: number;
    /**
     * 
     * @type {string}
     * @memberof FusionMelcoModelsDesign
     */
    file_type?: string | null;
    /**
     * 
     * @type {number}
     * @memberof FusionMelcoModelsDesign
     */
    image_resolution?: number;
    /**
     * 
     * @type {string}
     * @memberof FusionMelcoModelsDesign
     */
    original_file_name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FusionMelcoModelsDesign
     */
    file_extension?: string | null;
    /**
     * 
     * @type {Array<FusionMelcoModelsDesignElement>}
     * @memberof FusionMelcoModelsDesign
     */
    element_list?: Array<FusionMelcoModelsDesignElement> | null;
    /**
     * 
     * @type {string}
     * @memberof FusionMelcoModelsDesign
     */
    rfm_url?: string | null;
    /**
     * 
     * @type {Array<FusionMelcoModelsPreview>}
     * @memberof FusionMelcoModelsDesign
     */
    previews?: Array<FusionMelcoModelsPreview> | null;
    /**
     * 
     * @type {number}
     * @memberof FusionMelcoModelsDesign
     */
    publish_state?: number;
    /**
     * 
     * @type {Date}
     * @memberof FusionMelcoModelsDesign
     */
    created_date?: Date;
    /**
     * 
     * @type {Date}
     * @memberof FusionMelcoModelsDesign
     */
    publish_date?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof FusionMelcoModelsDesign
     */
    updated_date?: Date | null;
    /**
     * 
     * @type {Array<FusionMelcoModelsCustomWarning>}
     * @memberof FusionMelcoModelsDesign
     */
    warning_list?: Array<FusionMelcoModelsCustomWarning> | null;
}

export function FusionMelcoModelsDesignFromJSON(json: any): FusionMelcoModelsDesign {
    return FusionMelcoModelsDesignFromJSONTyped(json, false);
}

export function FusionMelcoModelsDesignFromJSONTyped(json: any, ignoreDiscriminator: boolean): FusionMelcoModelsDesign {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'file_name': !exists(json, 'file_name') ? undefined : json['file_name'],
        'signature': !exists(json, 'signature') ? undefined : json['signature'],
        'stitches': !exists(json, 'stitches') ? undefined : json['stitches'],
        'colors': !exists(json, 'colors') ? undefined : json['colors'],
        'trims': !exists(json, 'trims') ? undefined : json['trims'],
        'color_changes': !exists(json, 'color_changes') ? undefined : json['color_changes'],
        'unit': !exists(json, 'unit') ? undefined : json['unit'],
        'height': !exists(json, 'height') ? undefined : json['height'],
        'width': !exists(json, 'width') ? undefined : json['width'],
        'file_size': !exists(json, 'file_size') ? undefined : json['file_size'],
        'file_type': !exists(json, 'file_type') ? undefined : json['file_type'],
        'image_resolution': !exists(json, 'image_resolution') ? undefined : json['image_resolution'],
        'original_file_name': !exists(json, 'original_file_name') ? undefined : json['original_file_name'],
        'file_extension': !exists(json, 'file_extension') ? undefined : json['file_extension'],
        'element_list': !exists(json, 'element_list') ? undefined : (json['element_list'] === null ? null : (json['element_list'] as Array<any>).map(FusionMelcoModelsDesignElementFromJSON)),
        'rfm_url': !exists(json, 'rfm_url') ? undefined : json['rfm_url'],
        'previews': !exists(json, 'previews') ? undefined : (json['previews'] === null ? null : (json['previews'] as Array<any>).map(FusionMelcoModelsPreviewFromJSON)),
        'publish_state': !exists(json, 'publish_state') ? undefined : json['publish_state'],
        'created_date': !exists(json, 'created_date') ? undefined : (new Date(json['created_date'])),
        'publish_date': !exists(json, 'publish_date') ? undefined : (json['publish_date'] === null ? null : new Date(json['publish_date'])),
        'updated_date': !exists(json, 'updated_date') ? undefined : (json['updated_date'] === null ? null : new Date(json['updated_date'])),
        'warning_list': !exists(json, 'warning_list') ? undefined : (json['warning_list'] === null ? null : (json['warning_list'] as Array<any>).map(FusionMelcoModelsCustomWarningFromJSON)),
    };
}

export function FusionMelcoModelsDesignToJSON(value?: FusionMelcoModelsDesign | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
        'file_name': value.file_name,
        'signature': value.signature,
        'stitches': value.stitches,
        'colors': value.colors,
        'trims': value.trims,
        'color_changes': value.color_changes,
        'unit': value.unit,
        'height': value.height,
        'width': value.width,
        'file_size': value.file_size,
        'file_type': value.file_type,
        'image_resolution': value.image_resolution,
        'original_file_name': value.original_file_name,
        'file_extension': value.file_extension,
        'element_list': value.element_list === undefined ? undefined : (value.element_list === null ? null : (value.element_list as Array<any>).map(FusionMelcoModelsDesignElementToJSON)),
        'rfm_url': value.rfm_url,
        'previews': value.previews === undefined ? undefined : (value.previews === null ? null : (value.previews as Array<any>).map(FusionMelcoModelsPreviewToJSON)),
        'publish_state': value.publish_state,
        'created_date': value.created_date === undefined ? undefined : (value.created_date.toISOString()),
        'publish_date': value.publish_date === undefined ? undefined : (value.publish_date === null ? null : value.publish_date.toISOString()),
        'updated_date': value.updated_date === undefined ? undefined : (value.updated_date === null ? null : value.updated_date.toISOString()),
        'warning_list': value.warning_list === undefined ? undefined : (value.warning_list === null ? null : (value.warning_list as Array<any>).map(FusionMelcoModelsCustomWarningToJSON)),
    };
}


